import { FC, useEffect, useState } from "react";
import HeaderTableSuperAdmin from "../../../components/admin/common/HeaderTableSuperAdmin";
import AntTable from "../../../components/AntTable/AntTable";
import { useQuery } from "@tanstack/react-query";
import { getContactUsRequests } from "../../../network/admin";
import { Button, message, Modal, Popover, Spin } from "antd";
import { ColumnsType } from "antd/es/table";
import { RiMessage3Line } from "react-icons/ri";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import ContactUsDetails from "../../../components/admin/contact-us/ContactUsDetails";
import { contactUsRequest } from "../../../types/commonTypes";

interface ContactUsRequestsProps {}
const getStatusFormattedString = (status: string) => {
  switch (status) {
    case "new_lead":
      return "New Lead";
    case "contacted":
      return "Contacted";
    case "qualified":
      return "Qualified";
    case "closed_won":
      return "Closed (Won)";
    case "closed_lost":
      return "Closed (Lost)";
    default:
      return "New Lead";
  }
};
const ContactUsRequests: FC<ContactUsRequestsProps> = ({}) => {
  const [page, setPage] = useState<number>(1);
  const [contactRequest, setContactRequest] = useState<null | contactUsRequest>(
    null
  );
  //
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const [confirmMessage, setConfirmMessage] = useState({
    title: "",
    para: "",
    status: "",
    color: "",
  });
  const [isFilter, setIsFilter] = useState({});
  const [searchHeader, setSearchHeader] = useState();
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);

  //
  const actionItems = [
    {
      color: "#C43535",
      text: "Delete Team Members",
      title: "Confirm Deletion",
      description: "Are you sure you want to delete this Team Members?",
      status: "delete",
    },
  ];
  const { data, isLoading } = useQuery(["contactUsRequests", page], () =>
    getContactUsRequests({ page })
  );
  useEffect(() => {
    if (contactRequest) {
      const request = data?.data?.find(
        (r: { id: string }) => r?.id === contactRequest?.id
      );
      setContactRequest(request);
    }
  }, [data]);
  const columns: ColumnsType<any> = [
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Name</div>,
      dataIndex: "name",
      render: (text: any, record) => (
        <div className="text-color-primary text-sm font-normal">
          {record?.name || record?.business_name}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Form Name</div>
      ),
      dataIndex: "salon",

      render: (text: any, record) => (
        <div className="text-color-primary text-sm font-semibold" dir="ltr">
          <span>{record?.form_name}</span>
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Email address</div>
      ),
      dataIndex: "email",

      render: (text: any, record) => (
        <div className="text-color-primary text-sm font-base">
          {record?.email}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Phone Number</div>
      ),
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className="text-color-primary text-sm font-base">
          {record?.phone ? (
            <Button
              htmlType="button"
              type="text"
              className="mx-2"
              onClick={() => {
                navigator.clipboard.writeText(record?.phone);
                message.success("Phone Number Copied");
              }}
            >
              {record?.phone}
            </Button>
          ) : null}
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Type</div>,
      dataIndex: "Profession",

      render: (text: any, record) => (
        <div className={`text-color-primary text-sm font-base`}>
          {record?.salon_type}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Team Size</div>
      ),
      dataIndex: "Profession",

      render: (text: any, record) => (
        <div className={`text-color-primary text-sm font-base`}>
          {record?.team_size}
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Status</div>,
      dataIndex: "Profession",

      render: (text: any, record) => (
        <div className={`text-color-primary text-sm font-base`}>
          {getStatusFormattedString(record?.status)}
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">City</div>,
      dataIndex: "created_at",

      render: (text: any, record) => (
        <div className="text-color-primary text-sm font-base">
          <span className="w-full">{record?.business_location}</span>
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Message</div>,
      dataIndex: "created_at",

      render: (text: any, record) => (
        <div className="text-color-primary text-sm font-base">
          <span className="w-full">
            {record?.message ? (
              <Popover content={record?.message}>
                <RiMessage3Line size={20} className="text-color-primary" />
              </Popover>
            ) : null}
          </span>
        </div>
      ),
    },
  ];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }
  const showModalConfirm = (
    title: string,
    para: string,
    status: string,
    color: string
  ) => {
    setConfirmMessage({ title, para, status, color });
    setIsModalConfirmOpen(true);
  };
  const closeModalConfirm = () => {
    setIsModalConfirmOpen(false);
  };
  const deleteStaff = (data: any) => {
    console.log(data);
  };

  return (
    <div>
      {" "}
      <div className="bg-[#EEF0FF]">
        <AntTable
          tableColumns={columns}
          tableHeader={
            <div className="flex items-center justify-end">
              <HeaderTableSuperAdmin
                selectedRowKeys={selectedRowKeys}
                searchHeader={searchHeader}
                setSearchHeader={setSearchHeader}
                hasModal={false}
                setIsFilter={setIsFilter}
                filterType={{ bySalon: true, dateAdded: true }}
                modalId={0}
                actionItems={actionItems}
                confirmMessage={confirmMessage}
                requestDelete={deleteStaff}
                setConfirmMessage={setConfirmMessage}
                isModalConfirmOpen={isModalConfirmOpen}
                closeModalConfirm={closeModalConfirm}
                placeholderSearch="Search by salon, name .."
                showModalConfirm={showModalConfirm}
              />
            </div>
          }
          onRow={(record: any, rowIndex: any) => {
            return {
              onClick: (event: any) => {
                setContactRequest(record);
              }, // click row
            };
          }}
          tableData={data?.data || []}
          isLoading={isLoading}
          expandRowByClick={false}
          // selectedRowKeys={selectedRowKeys}
          // setSelectedRowKeys={setSelectedRowKeys}
          // selectionType={selectedRowKeys}
          setPage={setPage}
          page={page}
          total={data?.meta?.total}
        />
      </div>
      <Modal
        open={!!contactRequest}
        afterClose={() => {
          setContactRequest(null);
        }}
        footer={null}
        onCancel={() => {
          setContactRequest(null);
        }}
        width={700}
      >
        {contactRequest ? (
          <ContactUsDetails
            request={contactRequest}
            formattedStatus={getStatusFormattedString(contactRequest?.status)}
          />
        ) : null}
      </Modal>
    </div>
  );
};

export default ContactUsRequests;
